import { formatAstrolabeForAI } from "./ziweiService";
import { AstrolabeData, BirthDetails } from "../types";

const API_ENDPOINT = '/api/interpret';

export interface InterpretResult {
  stream: AsyncIterable<string>;
  readingId: string | null;
}

export const streamInterpretation = async (
  astrolabe: AstrolabeData,
  birthDetails: BirthDetails,
  userQuery: string | null
): Promise<InterpretResult> => {
  const contextData = formatAstrolabeForAI(astrolabe);

  // Extract hour from time string
  const [hourStr] = birthDetails.time.split(':');
  const birthHour = parseInt(hourStr, 10);

  const response = await fetch(API_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({
      astrolabeData: contextData,
      userQuery,
      birthDate: birthDetails.date,
      birthHour,
      gender: birthDetails.gender,
    }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
    throw new Error(errorData.error || `API error: ${response.status}`);
  }

  const readingId = response.headers.get('X-Reading-Id');

  const reader = response.body?.getReader();
  if (!reader) {
    throw new Error('No response body');
  }

  const stream = (async function* () {
    const decoder = new TextDecoder();
    let buffer = '';

    try {
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split('\n');
        buffer = lines.pop() || '';

        for (const line of lines) {
          if (line.startsWith('data: ')) {
            const data = line.slice(6).trim();
            if (data === '[DONE]') {
              return;
            }
            try {
              const parsed = JSON.parse(data);
              if (parsed.text) {
                yield parsed.text;
              }
            } catch {
              // Skip malformed JSON
            }
          }
        }
      }
    } finally {
      reader.releaseLock();
    }
  })();

  return { stream, readingId };
};
